/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiScenarioValidationResult
 */
export interface InternalApiScenarioValidationResult {
    /**
     * 
     * @type {boolean}
     * @memberof InternalApiScenarioValidationResult
     */
    isMatch: boolean;
    /**
     * 
     * @type {string}
     * @memberof InternalApiScenarioValidationResult
     */
    details?: string;
    /**
     * 
     * @type {number}
     * @memberof InternalApiScenarioValidationResult
     */
    executionTime?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof InternalApiScenarioValidationResult
     */
    relatedTransactions?: Array<number>;
}

/**
 * Check if a given object implements the InternalApiScenarioValidationResult interface.
 */
export function instanceOfInternalApiScenarioValidationResult(value: object): value is InternalApiScenarioValidationResult {
    if (!('isMatch' in value) || value['isMatch'] === undefined) return false;
    return true;
}

export function InternalApiScenarioValidationResultFromJSON(json: any): InternalApiScenarioValidationResult {
    return InternalApiScenarioValidationResultFromJSONTyped(json, false);
}

export function InternalApiScenarioValidationResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScenarioValidationResult {
    if (json == null) {
        return json;
    }
    return {
        
        'isMatch': json['isMatch'],
        'details': json['details'] == null ? undefined : json['details'],
        'executionTime': json['executionTime'] == null ? undefined : json['executionTime'],
        'relatedTransactions': json['relatedTransactions'] == null ? undefined : json['relatedTransactions'],
    };
}

export function InternalApiScenarioValidationResultToJSON(json: any): InternalApiScenarioValidationResult {
    return InternalApiScenarioValidationResultToJSONTyped(json, false);
}

export function InternalApiScenarioValidationResultToJSONTyped(value?: InternalApiScenarioValidationResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isMatch': value['isMatch'],
        'details': value['details'],
        'executionTime': value['executionTime'],
        'relatedTransactions': value['relatedTransactions'],
    };
}

